import { render, staticRenderFns } from "./MyItemsButton.vue?vue&type=template&id=1b4ebd2f&scoped=true"
import script from "./MyItemsButton.vue?vue&type=script&lang=js"
export * from "./MyItemsButton.vue?vue&type=script&lang=js"
import style0 from "./MyItemsButton.vue?vue&type=style&index=0&id=1b4ebd2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ebd2f",
  null
  
)

export default component.exports